@if (isDefined()) {
<app-header [nav]="nav" />
} @if (isDefined()) {
<h2 class="header">Audit: {{ audit.auditTitle }}</h2>
@if (canSave()) {
<button
  mat-raised-button
  (click)="save()"
  [disabled]="saving">
  @if (saving) {
  <mat-spinner
    diameter="20"
    class="button-spinner"></mat-spinner>
  <span>Saving...</span>
  } @else { Save }
</button>
}
<button
  mat-raised-button
  (click)="openDialog()"
  class="mat-raised-button edit">
  Close
</button>
<app-invalid-form-summary
  [errorText]="error"
  [invalidFields]="invalidFields"
  (fieldSelected)="goToInvalidField($event)" />
@if(form && organizations && audit){
<div [formGroup]="form">
  <mat-tab-group
    [selectedIndex]="tabPage"
    (selectedIndexChange)="updateTabs($event)">
    @if (!isDraft()) {
    <mat-tab label="Recommendations">
      <app-audit-recommendations
        [audit]="audit"
        [form]="form"></app-audit-recommendations>
    </mat-tab>
    }
    <mat-tab label="Audit Basics">
      <app-audit-basics
        [form]="form"
        [audit]="audit"
        [organizations]="organizations"></app-audit-basics>
    </mat-tab>
    <mat-tab label="Responsibles">
      <app-audit-responsibles
        (save)="save()"
        [form]="form"
        [editable]="chkEditable()"
        [organizations]="organizations"></app-audit-responsibles>
    </mat-tab>
    <mat-tab label="Files">
      <app-file-upload
        #fileUploader
        [fileLinkId]="fileLinkId"
        [onlyDownload]="chkEditable()"
        [form]="form"></app-file-upload>
    </mat-tab>
    <mat-tab label="Logs">
      @if (audit.announcements) {
      <mat-card>
        <app-audit-announcements [auditId]="audit.id"></app-audit-announcements>
      </mat-card>
      }
      <mat-card>
        <app-audit-log [auditId]="audit.id"></app-audit-log>
      </mat-card>
    </mat-tab>
  </mat-tab-group>
</div>
} } @else {
<h1>Loading...</h1>
} @if (!isDefined()) {
<mat-spinner class="spinner" />
}
